import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      if (!this.record.has('id')) {
        this.record.set('transls', [])
        this.record.get('transls').push({ lang: 'en', value: '' })
        this.record.set('checkAuto', true)
      }
    }

    onLoaded (record) {
      record.transls = [{ lang: record.lang, value: record.text, created_at: record.created_at, id: record.id }]
      const entityEnums = store.modalEntity
        ? record.parent
        : (store.router.params.entityname === linkConst.LINK_CATEG_SETTINGS ? 'FlyprivateCategories' : 'PricingTiers')
      const url = '/enums/' + record.value + '/' + entityEnums
      return store.requester.call(url, 'get').then(result => {
        record.transls = []
        if (result && result.data) {
          result.data.filter(i => i.lang === 'en').map(i => {
            record.transls.push({ lang: i.lang, value: i.text, created_at: i.created_at, id: i.id })
          })
          result.data.filter(i => i.lang !== 'en').map(i => {
            record.transls.push({ lang: i.lang, value: i.text, created_at: i.created_at, id: i.id })
          })
        }
        return record
      }).then((record) => {
        super.onLoaded(record)
      })
    }

    load (entityname, entityid) {
      this.createtitle = store.__(linkConst.LINK_ENUMS_TITLE) +
        defaultConst.TITLE_DIVIDER + store.__(defaultConst.TITLE_EDIT)
      const [parent, value] = entityid.split('|')
      const record = {
        parent: parent,
        value: value,
        id: value
      }
      this.onLoaded(record)
    }

    changeValue (attr, whereCond, value, attrs = null) {
      const found = attrs.find((i) => {
        for (const k in whereCond) {
          if (k === 'lang' && !whereCond[k]) { whereCond[k] = null }
          if (i[k] !== whereCond[k]) { return false }
        }
        return true
      })
      if (!found) {
        attrs.push(Object.assign({ value }, whereCond))
      } else {
        found.value = value
        found.updated = new Date()
      }
    }

    removeyRow (attr, row, val = null) {
      val.remove(row)
    }

    addRow (attr, row, val = null) {
      val.push(row)
    }

    addToLangTAB (lng, params) {
      const tempAttr = store.cv.attributes.find(j =>
        j.metadata_type === params.metadata_type &&
        j.language === lng &&
        j.attribute_id === params.attribute_id &&
        j.attribute_name_internal === params.attribute_name_internal
      )
      if (!tempAttr) {
        store.cv.attributes.push(Object.assign({}, params, { language: lng }))
      } else {
        tempAttr.attribute_value = params.attribute_value
      }
    }

    save () {
      this.state = 'saving'
      store.skipWarning = true
      const entityEnums = store.modalEntity
        ? this.record.get('parent')
        : (store.router.params.entityname === linkConst.LINK_CATEG_SETTINGS ? 'FlyprivateCategories' : 'PricingTiers')
      const value = this.record.get('value')
      const data = this.record.get('transls').map(i => ({
        id: i.id || null,
        parent: entityEnums,
        lang: i.lang,
        text: i.value.trim(),
        value: this.record.get('value').trim(),
        created_at: i.created_at || new Date(),
        updated_at: i.created_at ? new Date() : null
      }))

      if (store.modalEntity) {
        // don't save if no default language
        const defLangValue = data.find(i => i.lang === defaultConst.DEFAULT_LANG)
        if (!defLangValue || !defLangValue.text || defLangValue.text.length <= 0) {
          store.addMessage(defaultConst.DEFAULT_LANG.toUpperCase() + ' language is missing ', 'error')
          return new Promise((resolve) => { resolve(false) })
        }
        // modal window from languages
        const modalParams = store.modalEntity.params
        const origRecordID = this.record.get('transls').find(i => i.lang === defaultConst.DEFAULT_LANG)
        this.origRecordId = origRecordID ? origRecordID.id : this.origRecordId
        // remove unused languages
        store.cv.attributes = store.cv.attributes.filter((j, k) => {
          if (j.metadata_type === modalParams.metadata_type &&
              j.attribute_id === modalParams.attribute_id &&
              j.attribute_name_internal === modalParams.attribute_name_internal) {
            return (this.record.get('transls').find(i => i.lang === j.language))
          } else {
            return true
          }
        })
        // update store.cv.attributes
        this.record.get('transls').map(i => {
          this.addToLangTAB(
            i.lang,
            Object.assign({}, modalParams, { language: i.lang, attribute_value: i.value })
          )
        })
      }

      // save
      const url = !this.origRecordId ? '/enums' : `/enums/${encodeURIComponent(value)}/${entityEnums}`
      return store.requester.call(url, !this.origRecordId ? 'post' : 'put', data)
        .then(this.onSaved.bind(this))
        .then(this.flagEditDone(this.entityname, this.origRecordId || '_new'))
        .catch(this.onError.bind(this))
    }

    onSaved (saved) {
      store.markDirty('FlyprivateCategories')
      store.markDirty('PricingTiers')
      this.state = 'ready'
      return true // super.onSaved(saved)
    }

    requiredOptions = [
      'FilmCargoLanguages',
      'FlyPrivatePlatforms',
      'FlyprivateCategories',
      'PricingTiers'
    ]

    entityTitle = store.router && store.router.params && linkConst.LINKS_LIST[store.router.params.entityname]
    createtitle = store.__(this.entityTitle).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(this.entityTitle).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    saveAndReturnText = store.__(defaultConst.TITLE_SUBMIT)
    hideSubmitOnly = true

    validators = {
      _global: (vals) => {
        const errors = []
        const entityEnums = (store.router.params.entityname === linkConst.LINK_CATEG_SETTINGS ? 'FlyprivateCategories' : 'PricingTiers')

        if (vals && vals.has('transls') && vals.get('transls')) {
          let english = false
          vals.get('transls').map(i => {
            if (i.lang === 'en' && i.value.length > 0) {
              english = true
            }
          })
          if (!english) {
            errors.push('Please, set EN "Text".')
          }
        }
        if (!vals.has('value') || !vals.get('value') || (vals.get('value') && vals.get('value').trim() === '')) {
          errors.push('Please, set "Key" value.')
        }

        if (vals.has('value') && vals.get('value') && store.options.get(entityEnums)
          .find(i => i.value.toLowerCase().trim() === vals.get('value').toLowerCase().trim() && !vals.has('id'))) {
          errors.push('This "Key" already exists, please choose different.')
        }

        return errors.length > 0 ? errors : undefined
      }
    }
  }

  class TableState extends BaseTableState {
    entityTitle = store.router && store.router.params && linkConst.LINKS_LIST[store.router.params.entityname]

    attrs = [
      'id', 'value', 'text'
    ]

    headertitles = [
      store.__('ID'), store.__('Key'), store.__('Text')
    ]

    title = store.__(this.entityTitle)
    defaultSort = linkConst.DEFAULT_SORT[store.router.params.entityname]
    noDelete = true

    requiredOptions = [
      'FilmCargoLanguages',
      'FlyPrivatePlatforms',
      'FlyprivateCategories',
      'PricingTiers'
    ]

    init () {
      store.loadEnumOptions('FilmCargoLanguages')
      store.loadEnumOptions('FlyprivateCategories')
      store.loadEnumOptions('Platforms')
      store.loadEnumOptions('PricingTiers')
      return super.init()
    }
  }

  return { ManipState, TableState }
}
